<app-upload-document-button
  [allowedTypes]="acceptedDocumentsMimeTypes"
  [multiple]="false"
  [tooltip]="'Téléverser le document ' + (tag() | documentTagLabel) + ' manquant'"
  (uploaded)="onDocumentUploaded($event[0].id)"
>
  <app-text-icon [text]="tag() | documentTagToTextIcon"></app-text-icon>
</app-upload-document-button>
